import React, { createContext, useContext, useState } from "react";
import { fetchDeleteSegment, fetchOrders } from "../api";
import { useTimleneEditor } from "../components/Timeline/hooks/useTimleneEditor";

const TimelineContext = createContext();

// TODO: Разделить по логике данный контекст на хуки

export const TimelineProvider = ({ children, divisionId }) => {
  const [segments, setSegments] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [segmentTooltipData, setSegmentTooltipData] = useState(null);
  const [selectedOrderItemId, setSelectedOrderItemId] = useState(null);
  const [orderFormData, setOrderFormData] = useState(null);
  const [orderFormColor, setOrderFormColor] = useState("#FFFFFF");
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [visibleTimeStart, setVisibleTimeStart] = useState(null);
  const [visibleTimeEnd, setVisibleTimeEnd] = useState(null);
  const [selectedOperationCardId, setSelectedOperationCardId] = useState(null);
  const [lastClickTime, setLastClickTime] = useState(null);
  const [timer, setTimer] = useState(null);
  const [hash, setHash] = useState(null);
  const [orders, setOrders] = useState([]);

  const updateOrders = async () => {
    const orders = await fetchOrders(divisionId);
    setOrders(orders);
  };

  const updateHash = (newHash) => {
    setHash(newHash);
  };

  const updateLastClickTime = (time) => {
    setLastClickTime(time);
  };

  const updateTimer = (time) => {
    setTimer(time);
  };

  const useTimelineEditorConfig = (operation) => useTimleneEditor(operation);

  const addSelectedoperationCard = (operationCardId) => {
    setSelectedOperationCardId(operationCardId);
  };

  const resetSelectedOperationCard = () => {
    setSelectedOperationCardId(null);
  };

  const addTooltipPosition = ({ top, left }) => {
    setTooltipPosition({ top, left });
  };

  const selectSegment = (segmentId) => {
    if (!segmentId || segmentId.startsWith("temp-")) {
      setSelectedSegment(null);
      return;
    }

    // if(selectedSegment?.id !== segmentId){
    //   resetTimeline();
    // }

    const segment = segments.find((seg) => seg.id === segmentId);

    setSelectedSegment(segment.id);
  };

  const deleteSelectedSegment = async () => {
    if (selectedSegment) {
      await fetchDeleteSegment({ id: selectedSegment });
      updateOrders(divisionId);
      setSelectedSegment(null);
    }
  };

  const addGroups = (groups) => {
    setGroups(groups);
  };

  const addVisibleTimeStart = (date) => {
    setVisibleTimeStart(date);
  };

  const addVisibleTimeEnd = (date) => {
    setVisibleTimeEnd(date);
  };

  const addSegment = (newSegment) => {
    setSegments((prev) => {
      const existingIds = new Set(prev.map((segment) => segment.id));
      if (!existingIds.has(newSegment.id)) {
        return [...prev, newSegment];
      }
      return prev;
    });
    updateOrders(divisionId);
  };

  const updateSegment = (updatedSegment, properties) => {
    setSegments((prev) =>
      prev.map((segment) =>
        segment.id === updatedSegment.id
          ? {
              ...segment,
              style: {
                ...segment.style,
                ...properties,
              },
            }
          : segment
      )
    );
  };

  const resetSegments = () => {
    setSegments([]);
  };

  const removeSegment = (segmentId) => {
    setSegments((prev) => prev.filter((segment) => segment.id !== segmentId));
    updateOrders(divisionId);
  };

  const addSegmentTooltip = (data) => {
    setSegmentTooltipData(data);
  };

  const removeSegmentTooltip = () => {
    setSegmentTooltipData(null);
  };

  const fillBlockedSegment = (updatedSegment) => {
    setSegments((prev) =>
      prev.map((segment) =>
        segment.id === updatedSegment.id
          ? updatedSegment
          : {
              ...segment,
              canMove: false,
              canSelect: false,
              style: {
                ...segment.style,
                background: "rgba(216, 208, 208, 0.5)",
                minHeight: "50px",
              },
            }
      )
    );
  };

  const selectOrderItemId = (orderId) => {
    setSelectedOrderItemId(orderId);
  };

  const rollbackAllSegments = () => {
    setSegments(segments);
  };

  const addSegments = (newSegments) => {
    if (!Array.isArray(newSegments)) {
      console.error("❌ Ошибка: newSegments не является массивом!", newSegments);
      return;
    }
  
    setSegments((prev) => {
      const segmentMap = new Map(prev.map((segment) => [segment.id, segment]));
  
      newSegments.forEach((segment) => {
        segmentMap.set(segment.id, segment);
      });
  
      return Array.from(segmentMap.values());
    });
  
    updateOrders(divisionId);
  };  

  const addOrderFormData = (orderData) => {
    setOrderFormData(orderData);
  };

  const addOrderFormColor = (orderColor) => {
    setOrderFormColor(orderColor);
  };

  const resetFreeZoneSegments = () => {
    setSegments((prev) => {
      if (!Array.isArray(prev)) return [];

      return prev.filter((segment) => !segment.id.startsWith("free-zone-"));
    });
  };

  return (
    <TimelineContext.Provider
      value={{
        segments,
        addSegment,
        fillBlockedSegment,
        removeSegment,
        resetSegments,
        addGroups,
        groups,
        addSegments,
        rollbackAllSegments,
        deleteSelectedSegment,
        selectSegment,
        selectedSegment,
        segmentTooltipData,
        addSegmentTooltip,
        removeSegmentTooltip,
        addTooltipPosition,
        tooltipPosition,
        selectOrderItemId,
        selectedOrderItemId,
        addOrderFormData,
        addOrderFormColor,
        orderFormData,
        orderFormColor,
        addVisibleTimeStart,
        addVisibleTimeEnd,
        visibleTimeStart,
        visibleTimeEnd,
        selectedOperationCardId,
        addSelectedoperationCard,
        resetSelectedOperationCard,
        useTimelineEditorConfig,
        updateLastClickTime,
        updateTimer,
        timer,
        lastClickTime,
        updateHash,
        hash,
        updateOrders,
        orders,
        updateSegment,
        resetFreeZoneSegments,
      }}
    >
      {children}
    </TimelineContext.Provider>
  );
};

export const useTimeline = () => useContext(TimelineContext);
